export class ControlDocumentTransportOperator {
  constructor(
      public defaultControlDocumentTransportOperator?: string,
  ) { }

  clone() {
    return new ControlDocumentTransportOperator(
        this.defaultControlDocumentTransportOperator
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/control-document-transport-operator.ts